import { useState, useEffect } from 'react'
import Card, { CardHeader } from '../ui/Card'
import StatNumber from '../ui/StatNumber'
import SectionLabel from '../ui/SectionLabel'
import LoadingBear from '../ui/LoadingBear'
import { fetchRelational } from '../../api/client'

export default function RelationalArcPanel() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchRelational().then(setData).finally(() => setLoading(false))
  }, [])

  if (loading) return <LoadingBear message="Tracing the arc..." />

  return (
    <div>
      <SectionLabel>Panel 11 — Relational Arc</SectionLabel>

      <Card delay={0.05}>
        <CardHeader
          title="Relational Arc — Courtney"
          badge={`${data?.count ?? 0} entries`}
          badgeVariant="gold"
        />

        {/* Canvas chart placeholder — will be real canvas in Phase 3 */}
        <div className="h-[360px] flex items-center justify-center rounded-lg bg-mm-parchment/[0.04] mb-4">
          <p className="text-mm-parchment/30 text-sm">Bezier arc chart — wiring in Phase 3</p>
        </div>

        {/* Stats row */}
        <div className="grid grid-cols-4 gap-3">
          <div className="text-center p-3.5 bg-mm-parchment/[0.08] rounded-lg">
            <StatNumber value={data?.total ?? '—'} label="Total entries" color="gold" size="sm" />
          </div>
          <div className="text-center p-3.5 bg-mm-parchment/[0.08] rounded-lg">
            <StatNumber value={data?.dominant ?? '—'} label="Dominant" color="sage" size="sm" />
          </div>
          <div className="text-center p-3.5 bg-mm-parchment/[0.08] rounded-lg">
            <StatNumber value={data?.gaps ?? '—'} label="Gaps" color="persimmon" size="sm" />
          </div>
          <div className="text-center p-3.5 bg-mm-parchment/[0.08] rounded-lg">
            <StatNumber value={data?.trend ?? '—'} label="Trend" color="gold" size="sm" />
          </div>
        </div>
      </Card>
    </div>
  )
}
